module.exports = __webpack_public_path__ + "img/wheel_loader_h.4132dd77.png";